export default __webpack_public_path__ + "static/media/4-Inam-Hvor føler du deg mest hjemme.fc544c9f.mp4";